// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging"; // Import FCM functions
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA1WAgLuOJpvfOoHdxxWU8AvbVGYOtWm1U",
  authDomain: "akindervolunteer.firebaseapp.com",
  projectId: "akindervolunteer",
  storageBucket: "akindervolunteer.firebasestorage.app",
  messagingSenderId: "8456106534",
  appId: "1:8456106534:web:7af2bca7574339e0e2ace7",
  measurementId: "G-0FV0SNGJS4"
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

// Initialize Firebase Cloud Messaging
const messaging = getMessaging(firebaseApp);

// console log if firebase is initialized
console.log("Firebase initialized");

export { firebaseApp, messaging, getToken }; // Export messaging and getToken
